var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvioLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 42.941,
    viewBox: "0 0 146 42.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b,.c{fill:#2fffd1;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-188 -235.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M918.322,258.1v.065a4.637,4.637,0,0,0,1.5,3.356,13.911,13.911,0,0,1,4.207,10.16v.16c0,7.281-4.971,13.361-12.831,13.361-7.537,0-12.91-6.161-12.91-13.521v-.16a13.775,13.775,0,0,1,4.2-10.227,4.527,4.527,0,0,0,1.5-3.313h0a4.432,4.432,0,0,0-7.22-3.43,21.847,21.847,0,0,0-8.185,17.13v.16c0,12,9.543,21.843,22.454,21.843,13.072,0,22.7-10,22.7-22v-.16a21.616,21.616,0,0,0-8.032-16.95A4.535,4.535,0,0,0,918.322,258.1Z",
    transform: "translate(-599.728 -15.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1016.17,239.628a4.119,4.119,0,1,1,4.119,4.118,4.119,4.119,0,0,1-4.119-4.118",
    transform: "translate(-708.881 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188 236.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.49,286.578c-11.568,0-20.49-8.375-20.49-20.671v-.151c0-11.392,8.09-20.746,19.507-20.746,12.7,0,18.978,10.41,18.978,19.614A4.273,4.273,0,0,1,222.176,269H197.149c.983,6.489,5.6,10.109,11.493,10.109a14.367,14.367,0,0,0,9.451-3.471,3.414,3.414,0,0,1,2.344-.831,3.6,3.6,0,0,1,3.629,3.7,3.981,3.981,0,0,1-1.21,2.791A20.522,20.522,0,0,1,208.49,286.578Zm9.074-23.612c-.605-5.884-4.082-10.487-10.131-10.487-5.6,0-9.527,4.3-10.358,10.487Z",
    transform: "translate(-188 -245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M486.377,288.651h-.454c-2.5,0-4.159-1.585-5.217-4L467.4,254.25a7.1,7.1,0,0,1-.529-2.264,4.568,4.568,0,0,1,4.536-4.376c2.5,0,3.78,1.433,4.536,3.319l10.283,26.4,10.433-26.555a4.553,4.553,0,0,1,4.309-3.168,4.353,4.353,0,0,1,4.461,4.376,5.455,5.455,0,0,1-.529,2.187l-13.308,30.478C490.536,286.991,488.873,288.651,486.377,288.651Z",
    transform: "translate(-426.571 -247.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M776.09,252.222a4.514,4.514,0,0,1,4.536-4.6,4.578,4.578,0,0,1,4.613,4.6v31.533a4.575,4.575,0,0,1-9.149,0Z",
    transform: "translate(-691.107 -247.243)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvioLogo);
export default __webpack_public_path__ + "static/media/EVIO_logo.392cd93c8e268fe46ae8766ec7dfb300.svg";
export { ForwardRef as ReactComponent };